import { t } from 'i18next';

import { PwcOrderStatus } from 'types/pwcOrder';

const STATUS_LABELS: Record<PwcOrderStatus, [string, string]> = {
  [PwcOrderStatus.Initiated]: ['page.pwcOrders.components.status.initiated', 'Initiated'],
  [PwcOrderStatus.Pending]: ['page.pwcOrders.components.status.pending', 'Pending'],
  [PwcOrderStatus.Submitted]: ['page.pwcOrders.components.status.submitted', 'Submitted'],
  [PwcOrderStatus.Confirmed]: ['page.pwcOrders.components.status.confirmed', 'Confirmed'],
  [PwcOrderStatus.Completed]: ['page.pwcOrders.components.status.completed', 'Completed'],
  [PwcOrderStatus.Incomplete]: ['page.pwcOrders.components.status.incomplete', 'Incomplete'],
  [PwcOrderStatus.Overpaid]: ['page.pwcOrders.components.status.overpaid', 'Overpaid'],
  [PwcOrderStatus.Expired]: ['page.pwcOrders.components.status.expired', 'Expired'],
  [PwcOrderStatus.Canceled]: ['page.pwcOrders.components.status.canceled', 'Cancelled'],
  [PwcOrderStatus.Declined]: ['page.pwcOrders.components.status.declined', 'Declined'],
  [PwcOrderStatus.Failed]: ['page.pwcOrders.components.status.failed', 'Failed'],
  [PwcOrderStatus.RefundInitiated]: ['page.pwcOrders.components.status.refundInitiated', 'Refund Initiated'],
  [PwcOrderStatus.RefundSubmitted]: ['page.pwcOrders.components.status.refundSubmitted', 'Refund Submitted'],
  [PwcOrderStatus.RefundFailed]: ['page.pwcOrders.components.status.refundFailed', 'Refund Failed'],
  [PwcOrderStatus.Refunded]: ['page.pwcOrders.components.status.refunded', 'Refunded'],
  [PwcOrderStatus.PartialRefund]: ['page.pwcOrders.components.status.partialRefund', 'Partial Refund'],
};

export const LABELS = {
  STATUS: STATUS_LABELS,
};

export const badgePropsMap: Record<PwcOrderStatus, { type: PwcOrderStatus; label: string }> = {
  [PwcOrderStatus.Initiated]: {
    type: PwcOrderStatus.Initiated,
    label: t(LABELS.STATUS.INITIATED),
  },
  [PwcOrderStatus.Pending]: {
    type: PwcOrderStatus.Pending,
    label: t(LABELS.STATUS.PENDING),
  },
  [PwcOrderStatus.Submitted]: {
    type: PwcOrderStatus.Submitted,
    label: t(LABELS.STATUS.SUBMITTED),
  },
  [PwcOrderStatus.Confirmed]: {
    type: PwcOrderStatus.Confirmed,
    label: t(LABELS.STATUS.CONFIRMED),
  },
  [PwcOrderStatus.Completed]: {
    type: PwcOrderStatus.Completed,
    label: t(LABELS.STATUS.COMPLETED),
  },
  [PwcOrderStatus.Incomplete]: {
    type: PwcOrderStatus.Incomplete,
    label: t(LABELS.STATUS.INCOMPLETE),
  },
  [PwcOrderStatus.Overpaid]: {
    type: PwcOrderStatus.Overpaid,
    label: t(LABELS.STATUS.OVERPAID),
  },
  [PwcOrderStatus.Expired]: {
    type: PwcOrderStatus.Expired,
    label: t(LABELS.STATUS.EXPIRED),
  },
  [PwcOrderStatus.Canceled]: {
    type: PwcOrderStatus.Canceled,
    label: t(LABELS.STATUS.CANCELED),
  },
  [PwcOrderStatus.Declined]: {
    type: PwcOrderStatus.Declined,
    label: t(LABELS.STATUS.DECLINED),
  },
  [PwcOrderStatus.Failed]: {
    type: PwcOrderStatus.Failed,
    label: t(LABELS.STATUS.FAILED),
  },
  [PwcOrderStatus.RefundInitiated]: {
    type: PwcOrderStatus.RefundInitiated,
    label: t(LABELS.STATUS.REFUND_INITIATED),
  },
  [PwcOrderStatus.RefundSubmitted]: {
    type: PwcOrderStatus.RefundSubmitted,
    label: t(LABELS.STATUS.REFUND_SUBMITTED),
  },
  [PwcOrderStatus.RefundFailed]: {
    type: PwcOrderStatus.RefundFailed,
    label: t(LABELS.STATUS.REFUND_FAILED),
  },
  [PwcOrderStatus.Refunded]: {
    type: PwcOrderStatus.Refunded,
    label: t(LABELS.STATUS.REFUNDED),
  },
  [PwcOrderStatus.PartialRefund]: {
    type: PwcOrderStatus.PartialRefund,
    label: t(LABELS.STATUS.PARTIAL_REFUND),
  },
};
